import { takeEvery } from 'redux-saga'
import { put, call, select, fork } from 'redux-saga/effects'
import { createMobileProjectSelector } from 'selectors'
import { deviceCountSelector } from 'selectors/components'
import { startAutosaveSagaAction, notifyHoneybadgerAction, hideMobileStartAction } from 'actions/applicationActions'
import { expandProjectAction, addProjectAction, updateProjectAction } from 'actions/projectActions'
import { CREATE_MOBILE_PROJECT } from 'actions/projectActionTypes'
import { notificationAction } from 'actions/notificationActions'
import createDocumentSaga from 'sagas/createDocumentSaga'
import initialProject from 'helpers/projects/initialProject'
import { getSettings } from 'sagas/setupProjectsSaga/findBySelector'
import createDocument from 'helpers/databases/createDocument'
import defaultSettings, { addDefaultSettings } from 'helpers/defaultSettings'
import offlineTimerSaga from 'sagas/offlineTimerSaga'

export function * createMobileProject(action) {
  try {
    const { location, zoom } = action
    const { database, showMobileStart, offline, active } = yield select(createMobileProjectSelector)

    const defaultProject = initialProject()
    const document = Object.assign({}, defaultProject, { location, zoom })

    if (!offline) {
      const idAndRev = yield call(createDocumentSaga, document)
      const project = { ...document, ...idAndRev }

      let settings = yield call(getSettings, database)

      if (!settings) {
        yield call(createDocument, database, defaultSettings)
        settings = defaultSettings
      } else settings = addDefaultSettings(settings)

      if (showMobileStart) {
        const deviceCount = yield select(deviceCountSelector)
        yield put(updateProjectAction({ deviceCount }))
      }

      yield put(addProjectAction(project))
      yield put(expandProjectAction(project, false, active, false, settings))

      showMobileStart ? yield put(hideMobileStartAction()) : yield put(startAutosaveSagaAction())
    } else {
      yield put(expandProjectAction(document, true, active))
      yield fork(offlineTimerSaga)
    }
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, { type: CREATE_MOBILE_PROJECT, skipThrow: true }))
    yield put(notificationAction('Could not create project', CREATE_MOBILE_PROJECT))
  }
}

export function * watchCreateMobileProject() {
  yield * takeEvery(CREATE_MOBILE_PROJECT, createMobileProject)
}



// WEBPACK FOOTER //
// ./src/sagas/createMobileProjectSaga.js